module.exports = __webpack_public_path__ + "r-v3/img/neon-pen_on.9a318d4a.svg";